module.exports = __webpack_public_path__ + "img/regComm-3.f587b06e.jpg";